export enum DiaryViewTypes {
  Live = 'Live',
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Branch = 'Branch'
}
